import { t } from 'i18next'
import { ErrorCode, FileError, FileRejection } from 'react-dropzone'
import { DefaultTheme } from '../applications/Embed/fragments/ThemeWrapper'

export const getFileValidationErrorMessage = (
  fileRejections: FileRejection[],
  theme: DefaultTheme
): string => {
  const FileValidationErrorMessage = {
    tooLargeFileSize: t('scenes.1_initialScene.fileTooLargeError'),
    invalidFileType: t(theme.textOverrides.invalidFileType)
  }

  const has = (code: ErrorCode) => (error: FileError) => error.code === code
  const errors = fileRejections.reduce((errors, fr) => [...errors, ...fr.errors], [])

  if (errors.some(has(ErrorCode.FileInvalidType))) {
    return FileValidationErrorMessage.invalidFileType
  } else if (errors.some(has(ErrorCode.FileTooLarge))) {
    return FileValidationErrorMessage.tooLargeFileSize
  } else return ''
}
